import React from "react";
import { PageHeader } from "@finitless/shared/components";
import { useTranslation } from "react-i18next";
import {
  usePlatformSettingsCategories,
  useProPreorderSettings,
} from "../../hooks/useSettings";
import { Icon } from "../ui/UIElements/Icon";
import SettingsCategory from "./settings/SettingsCategory";
import SettingsSkeleton from "./settings/SettingsSkeleton";

const SettingsPage = ({ selectedBrand }) => {
  const { t } = useTranslation("settings");
  const {
    data: platformCategories,
    isLoading: platformLoading,
    error: platformError,
    shouldShowNoData,
    shouldShowNoSettings,
  } = usePlatformSettingsCategories();

  const {
    data: proPreorderCategories,
    isLoading: proLoading,
    error: proError,
  } = useProPreorderSettings();

  const categories = [
    ...(platformCategories || []),
    ...(proPreorderCategories || []),
  ];

  const isLoading = platformLoading || proLoading;
  const error = platformError || proError;

  return (
    <div>
      <PageHeader
        title={t("header.title")}
        subtitle={t("header.subtitle")}
        selectedBrand={selectedBrand}
      />

      <div className="space-y-6">
        {isLoading ? (
          <SettingsSkeleton />
        ) : error ? (
          <div className="rounded-lg bg-gray-800 p-8 text-center">
            <div className="flex items-center justify-center space-x-2 text-red-400">
              <Icon name="AlertCircle" className="h-5 w-5" />
              <span>{t("errors.loadFailed")}</span>
            </div>
          </div>
        ) : shouldShowNoData ? (
          <div className="rounded-lg bg-gray-800 p-8 text-center">
            <Icon
              name="Settings"
              className="mx-auto mb-4 h-12 w-12 text-gray-400 opacity-50"
            />
            <h3 className="mb-2 text-xl font-medium text-white">
              {t("empty.platformNotFoundTitle")}
            </h3>
            <p className="text-gray-400">
              {t("empty.platformNotFoundDescription")}
            </p>
          </div>
        ) : shouldShowNoSettings ? (
          <div className="rounded-lg bg-gray-800 p-8 text-center">
            <Icon
              name="Settings"
              className="mx-auto mb-4 h-12 w-12 text-gray-400 opacity-50"
            />
            <h3 className="mb-2 text-xl font-medium text-white">
              {t("empty.noSettingsTitle")}
            </h3>
            <p className="text-gray-400">{t("empty.noSettingsDescription")}</p>
          </div>
        ) : categories && categories.length > 0 ? (
          <div className="space-y-6">
            {categories.map((category) => (
              <SettingsCategory key={category.id} category={category} />
            ))}
          </div>
        ) : (
          <div className="rounded-lg bg-gray-800 p-8 text-center">
            <Icon
              name="Settings"
              className="mx-auto mb-4 h-12 w-12 text-gray-400 opacity-50"
            />
            <h3 className="mb-2 text-xl font-medium text-white">
              {t("empty.noSettingsTitle")}
            </h3>
            <p className="text-gray-400">{t("empty.noSettingsDescription")}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SettingsPage;
